export default async ({
    req,
    res,
    route,
    redirect
}) => {
    // console.log(route.meta);
    // console.log(route.name);
    var token = null;
    if (process.server) {
        token = req.cookies["token"];
    } else {
        token = require('js-cookie').get('token');
    }
    if (!token && !route.meta.pubView) {
        redirect({
            name: 'login'
        });
    }
    if (token && route.name === "login") {
        // console.log(899);
        redirect({
            name: 'cases'
        });
    }
};